
// Mock data for development and testing
import { Voucher } from "@/components/dashboard/VoucherList";
import { CampaignCardProps } from "@/components/dashboard/CampaignCard";

// Generate a random voucher code
const generateVoucherCode = () => {
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

// Mock campaign data
export const mockCampaigns: (CampaignCardProps & { campaignType: "unique" | "common" })[] = [
  {
    id: "campaign-1",
    title: "Summer Beer Festival",
    description: "Special promotion for our summer festival with exclusive beer tasting vouchers.",
    status: "active",
    vouchersClaimed: 45,
    vouchersTotal: 100,
    startDate: new Date(2025, 3, 1), // April 1, 2025
    endDate: new Date(2025, 4, 30), // May 30, 2025
    campaignType: "unique"
  },
  {
    id: "campaign-2",
    title: "Craft Beer Week",
    description: "Celebrate craft beer week with special discounts at participating venues.",
    status: "scheduled",
    vouchersClaimed: 0,
    vouchersTotal: 200,
    startDate: new Date(2025, 5, 15), // June 15, 2025
    endDate: new Date(2025, 5, 22), // June 22, 2025
    campaignType: "common"
  },
  {
    id: "campaign-3",
    title: "Happy Hour Specials",
    description: "Two-for-one specials during happy hour at select locations.",
    status: "active",
    vouchersClaimed: 89,
    vouchersTotal: 150,
    startDate: new Date(2025, 2, 15), // March 15, 2025
    endDate: new Date(2025, 5, 15), // June 15, 2025
    campaignType: "unique"
  },
  {
    id: "campaign-4",
    title: "New Brew Launch",
    description: "Exclusive tasting of our new seasonal brew before public release.",
    status: "draft",
    vouchersClaimed: 0,
    vouchersTotal: 50,
    startDate: new Date(2025, 6, 1), // July 1, 2025
    endDate: new Date(2025, 6, 15), // July 15, 2025
    campaignType: "common"
  },
  {
    id: "campaign-5",
    title: "Winter Warmer",
    description: "Special deals on winter ales and stouts.",
    status: "ended",
    vouchersClaimed: 120,
    vouchersTotal: 150,
    startDate: new Date(2024, 11, 1), // December 1, 2024
    endDate: new Date(2025, 1, 31), // February 28, 2025
    campaignType: "unique"
  },
];

// Mock voucher data
export const mockVouchers: Voucher[] = Array.from({ length: 20 }, (_, i) => {
  const campaignIndex = Math.floor(Math.random() * mockCampaigns.length);
  const campaign = mockCampaigns[campaignIndex];
  const isActive = Math.random() > 0.6;
  const isRedeemed = !isActive && Math.random() > 0.5;
  const isExpired = !isActive && !isRedeemed;
  
  let status: "active" | "redeemed" | "expired" = "active";
  if (isRedeemed) status = "redeemed";
  if (isExpired) status = "expired";
  
  return {
    id: `voucher-${i + 1}`,
    code: generateVoucherCode(),
    campaign: campaign.title,
    claimed: isActive || isRedeemed || isExpired ? {
      date: new Date(Date.now() - Math.floor(Math.random() * 30 * 24 * 60 * 60 * 1000)),
      by: `user${Math.floor(Math.random() * 100) + 1}@example.com`,
    } : undefined,
    redeemed: isRedeemed ? {
      date: new Date(Date.now() - Math.floor(Math.random() * 15 * 24 * 60 * 60 * 1000)),
      location: ["The Beer Garden", "Hops & Dreams", "Craft Corner", "Brew House", "Malt Masters"][Math.floor(Math.random() * 5)],
    } : undefined,
    status,
    expires: new Date(Date.now() + (isExpired ? -1 : 1) * Math.floor(Math.random() * 60 * 24 * 60 * 60 * 1000)),
  };
});

// Dashboard statistics
export const mockStats = {
  totalVouchers: 650,
  activeVouchers: 325,
  redeemedVouchers: 185,
  activeCampaigns: 3
};
